import { render } from "./Home.vue?vue&type=template&id=71a61bcc&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=71a61bcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71a61bcc"

export default script